import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header, Footer } from "./components/Layout";
import Home from "./pages/Home";
import CommonNumber from "./pages/CommonNumber";
import DreamNumber from "./pages/DreamNumber";
import PreviousResult from "./pages/PreviousResult";
import Analysis from "./pages/Analysis";
import PredictTarget from "./pages/PredictTarget";
import ClubChart from "./pages/ClubChart";
import Counter from "./pages/Counter";
import Blog from "./pages/Blog";
import AppDownload from "./pages/AppDownload";
import Admin from "./pages/Admin";
import ScrollToTop from "./components/ScrollToTop";
import SeoLanding from "./components/SeoLanding";
import { SEO_PAGES } from "./data/seoPages";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/common-number" element={<CommonNumber />} />
            <Route path="/dream-number" element={<DreamNumber />} />
            <Route path="/previous-result" element={<PreviousResult />} />
            <Route path="/analysis" element={<Analysis />} />
            <Route path="/predict-target" element={<PredictTarget />} />
            <Route path="/club-chart" element={<ClubChart />} />
            <Route path="/counter" element={<Counter />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/app-download" element={<AppDownload />} />
            <Route path="/admin" element={<Admin />} />
            {SEO_PAGES.map((cfg) => (
              <React.Fragment key={cfg.canonicalPath}>
                <Route path={cfg.canonicalPath} element={<SeoLanding {...cfg} />} />
                <Route
                  path={cfg.canonicalPath.replace(/\/$/, "")}
                  element={<SeoLanding {...cfg} />}
                />
              </React.Fragment>
            ))}
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
